import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { UsersService } from "../services/users.service";

@Component({
  selector: "side-bar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  currUser;
  menuList = [];

  constructor(private route: Router, private usersService: UsersService) {
    this.checkRoute();
  }

  ngOnInit() {
    this.initMenu(this.route.url);
    this.subscriptions.push(
      this.usersService.currentUser.subscribe((user) => {
        this.currUser = user;
        this.setMenuForUser(user.roles);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  active(itemId): void {
    this.menuList.forEach((menu) => {
      menu.active = false;

      if (menu.idString === itemId) menu.active = true;
    });
  }

  checkRoute(): void {
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(event);
      }
    });
  }

  resize() {
    var menu = document.getElementById("mainPanel");
    var sidebar = document.getElementById("sidebar");
    var toggle = document.getElementById("toggleMenu");

    if (sidebar.classList.contains("show")) {
      sidebar.classList.remove("show");
      menu.style.width = "100%";
      toggle.classList.remove("on");
    } else {
      sidebar.classList.add("show");
      menu.style.width = "calc(100% - 260px)";
      toggle.classList.add("on");
    }
  }

  setMenuForUser(roles) {
    if (roles) {
      roles.forEach((rol) => {
        this.menuList.forEach((menu) => {
          if (menu.rol === rol.name) menu.show = true;
        });
      });
    }
  }

  initMenu(url) {
    if (!url) url = "";

    this.menuList = [

      {
        idString: "myDataMenu",
        active: url == "/datos" ? true : false,
        routerLink: "/datos",
        sourceImg: "./assets/img/misdatos.png",
        title: "Mis Datos",
        show: false,
        rol: "datosRol",
        specificClass: "",
      },
      {
        idString: "useradministrationMenu",
        active: url == "/usuario" ? true : false,
        routerLink: "/usuario",
        sourceImg: "./assets/img/ic_people.png",
        title: "Administración",
        show: false,
        rol: "usuarioRol",
        specificClass: "userAdmin",
      },
      {
        idString: "documentsMenu",
        active: url == "/documentacion" ? true : false,
        routerLink: "/documentacion",
        sourceImg: "./assets/img/documentos.png",
        title: "Mi Documentación",
        show: false,
        rol: "documentacionRol",
        specificClass: "",
      },
      {
        idString: "vehiclesMenu",
        active: url == "/unidades" ? true : false,
        routerLink: "/unidades",
        sourceImg: "./assets/img/colectivo.png",
        title: "Vehículos Vigentes",
        show: false,
        rol: "unidadesRol",
        specificClass: "",
      },
      {
        idString: "stateAccountMenu",
        active: url == "/documentacion/estado" ? true : false,
        routerLink: "/documentacion/estado",
        sourceImg: "./assets/img/ecuenta.png",
        title: "Estado de Cuenta",
        show: false,
        rol: "estadocuentaRol",
        specificClass: "",
      },
      {
        idString: "franquiciaFinanciadaMenu",
        active: url == "/deductible" ? true : false,
        routerLink: "/deductible",
        sourceImg: "./assets/img/documentos.png",
        title: "Inventario",
        show: false,
        rol: "inventarioRol",
        specificClass: "",
      },
      {
        idString: "driversMenu",
        active: url == "/conductor" ? true : false,
        routerLink: "/conductor",
        sourceImg: "./assets/img/conductor.png",
        title: "Conductores",
        show: false,
        rol: "conductorRol",
        specificClass: "",
      },
      {
        idString: "complainMenu",
        active: url == "/denuncia" ? true : false,
        routerLink: "/denuncia",
        sourceImg: "./assets/img/crash.png",
        title: "Mis Denuncias",
        show: false,
        rol: "denunciaRol",
        specificClass: "",
      },
      {
        idString: "cartaDocumentoMenu",
        active: url == "/letter" ? true : false,
        routerLink: "/letter",
        sourceImg: "./assets/img/pen.png",
        title: "Carta Documento",
        show: false,
        rol: "cartaDocumentoRol",
        specificClass: "",
      },
      {
        idString: "precargaSinDenunciaMenu",
        active: url == "/precargas-sin-denuncia" ? true : false,
        routerLink: "/precargas-sin-denuncia",
        sourceImg: "./assets/img/balance.png",
        title: "Precargas del Tercero Web Sin Denuncia",
        show: false,
        rol: "genericoRol",
        specificClass: "",
      },
      {
        idString: "claimMenu",
        active: url == "/claim" ? true : false,
        routerLink: "/claim",
        sourceImg: "./assets/img/balance.png",
        title: "Reclamos Sin Denuncia",
        show: false,
        rol: "reclamoSinDenunciaRol",
        specificClass: "",
      },
      {
        idString: "migratedClaimMenu",
        active: url == "/migratedclaim" ? true : false,
        routerLink: "/migratedclaim",
        sourceImg: "./assets/img/images.png",
        title: "Imagenes de Reclamos",
        show: false,
        rol: "imagenesRol",
        specificClass: "",
      },
      {
        idString: "migratedSinesterMenu",
        active: url == "/migratedsinester" ? true : false,
        routerLink: "/migratedsinester",
        sourceImg: "./assets/img/images.png",
        title: "Imagenes de Siniestros",
        show: false,
        rol: "imagenesRol",
        specificClass: "",
      },
      {
        idString: "notificationesMenu",
        active: url == "/notification" ? true : false,
        routerLink: "/notification",
        sourceImg: "./assets/img/ic_people.png",
        title: "Notificaciones",
        show: false,
        rol: "NotificacionesRol",
        specificClass: "userAdmin",
      }
    ];
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/sidebar/sidebar.component.ts